"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetClientDetails = void 0;
const Base_1 = require("./Base");
exports.GetClientDetails = {
    url: Base_1.URL_BASE + "/GetClientDetails",
    method: "GET",
    secure: true
};
//# sourceMappingURL=GetClientDetails.js.map